module.exports = __webpack_public_path__ + "static/assets/b04eb2a4928d8bf607c3cc1f90b22a82.png";